var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-stream-wrapper"},[_c('video',{staticClass:"video-preview",attrs:{"muted":"","src":_vm.videoLink,"controls":"","autoplay":"","controlsList":"nodownload nofullscreen noremoteplayback noplaybackrate","disablePictureInPicture":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }